import React from "react";
import Box from "@mui/material/Box";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import NavigationDrawer from "./navigation-drawer";
import { useTranslation } from "react-i18next";
import { setTabsOnDrawerOpen } from "../../services/shared";
import { useSelector, useDispatch } from "react-redux";
import {
  setIsDrawerOpen,
  setMapDialog,
  setSelectedNavigationTab,
} from "../../redux/actions/shared-actions";

/**
 * The tabs are actually the navigation buttons, each button corresponds to a specific layer which
 * is referencing the layers object created in the component itself.
 * @component
 * @category Components
 * @subcategory Navigation
 */

const NavigationTabs = () => {
  const { t } = useTranslation();
  const layers = {
    PUBLIC_TRANSIT: {
      bus: {
        iconURL: "/icons/bus.webp",
        title: "BUSES",
      },
      tram: {
        iconURL: "/icons/tram.webp",
        title: "TRAMS",
      },
      trolley: {
        iconURL: "/icons/trolley.webp",
        title: "TROLLEYS_AND_EBUSES",
      },
      subwayStations: {
        iconURL: "/icons/subway.webp",
        title: "SUBWAY",
      },
    },
    ALTERNATIVE_TRANSIT: {
      cycleways: {
        iconURL: "/icons/cycleways.webp",
        title: "CYCLEWAYS",
      },
      hobo: {
        iconURL: "/icons/hobo.webp",
        title: "HOBO",
      },
      spark: {
        iconURL: "/icons/spark.webp",
        title: "SPARK",
      },
      charger: {
        iconURL: "/icons/charger.webp",
        title: "CHARGERS",
      },
    },
    GREEN_INFRASTRUCTURE: {
      greenCorridor1: {
        iconURL: "/icons/polygon.webp",
        title: "CORRIDOR1",
      },
      greenCorridor2: {
        iconURL: "/icons/polygon.webp",
        title: "CORRIDOR2",
      },
      greenCorridor3: {
        iconURL: "/icons/polygon.webp",
        title: "CORRIDOR3",
      },
    },
    //kanachkova
    RECONSTRUCTIONS: {
      reconstructionsTemporary: {
        iconURL: null,
        title: "REPAIRWORKS_ZONE",
      },
      reconstructionsPermanent: {
        iconURL: null,
        title: "REPAIRWORKS_POINT",
      },
    },
  };

  const { isMapDialogOpen } = useSelector((state) => ({
    isMapDialogOpen: state.shared.isMapDialogOpen,
  }));
  const dispatch = useDispatch();
  const [value, setValue] = React.useState(0);
  const [drawerTitle, setDrawerTitle] = React.useState("PUBLIC_TRANSIT");
  const [drawerLayer, setDrawerLayer] = React.useState(
    layers["PUBLIC_TRANSIT"]
  );
  const drawerOnClose = () => {
    dispatch(setIsDrawerOpen(false));
  };

  const handleDrawerOpen = (title, layer) => {
    //kanachkova
    if (title === "RECONSTRUCTIONS" && value !== 3) {
      setTabsOnDrawerOpen(title);
    }

    if (title === "GREEN_INFRASTRUCTURE" && value !== 2) {
      setTabsOnDrawerOpen(title);
    }

    if (title === "ALTERNATIVE_TRANSIT" && value !== 1) {
      setTabsOnDrawerOpen(title);
    }
    if (title === "PUBLIC_TRANSIT" && value !== 0) {
      setTabsOnDrawerOpen(title);
    }

    setDrawerTitle(title);
    setDrawerLayer(layer);
    dispatch(setSelectedNavigationTab(title));
    if (isMapDialogOpen) {
      dispatch(setMapDialog(false));
    }
  };

  const handleChange = (_, newValue) => {
    setValue(newValue);
  };
  const leftArrowSVG = document.querySelector(
    "#root > div.navigation > div.MuiBox-root > div.MuiTabs-root> div:nth-child(1) > svg"
  );
  const tabsPortraitArrowClick = (e) => {
    if (
      e.target.tagName &&
      e.target.tagName !== "button" &&
      e.target.tagName !== "path" &&
      e.target.firstChild.tagName &&
      e.target.firstChild.tagName !== "DIV" &&
      window.matchMedia("(orientation: portrait)").matches &&
      window.innerWidth < 421
    ) {
      let sumIndexValue = 0;
      const leftArrow =
        e.target.getAttribute("data-testid") === "KeyboardArrowLeftIcon" ||
        e.target.firstChild.getAttribute("data-testid") ===
          "KeyboardArrowLeftIcon"
          ? "KeyboardArrowLeftIcon"
          : null;
      const rightArrow =
        e.target.getAttribute("data-testid") === "KeyboardArrowRightIcon" ||
        e.target.firstChild.getAttribute("data-testid") ===
          "KeyboardArrowRightIcon"
          ? "KeyboardArrowRightIcon"
          : null;
      if (leftArrow && leftArrowSVG.style.visibility === "visible") {
        setValue(value - 1);
        sumIndexValue = -1;
      }
      if (rightArrow && value !== Object.keys(layers).length - 1) {
        setValue(value + 1);
        sumIndexValue = +1;
      }
      const title = Object.keys(layers)[value + sumIndexValue];
      handleDrawerOpen(title, layers[title]);
    }
  };

  React.useEffect(() => {
    if (leftArrowSVG) {
      leftArrowSVG.style.visibility =
        value === 0 &&
        window.matchMedia("(orientation: portrait)").matches &&
        window.innerWidth < 421
          ? "hidden"
          : "visible";
    }
    // eslint-disable-next-line
  }, [value]);

  React.useEffect(() => {
    if (isMapDialogOpen) {
      dispatch(setIsDrawerOpen(false));
    }
  }, [isMapDialogOpen, dispatch]);

  return (
    <Box sx={{ width: "100%", bgcolor: "background.paper" }}>
      <Tabs
        value={value}
        onChange={handleChange}
        variant="scrollable"
        allowScrollButtonsMobile
        onClick={(e) => tabsPortraitArrowClick(e)}
      >
        {Object.keys(layers).map((drawerTitle) => {
          return (
            <Tab
              label={t(drawerTitle)}
              key={drawerTitle}
              onClick={() => handleDrawerOpen(drawerTitle, layers[drawerTitle])}
            />
          );
        })}
      </Tabs>
      <NavigationDrawer
        drawerOnClose={drawerOnClose}
        title={drawerTitle}
        layer={drawerLayer}
      />
    </Box>
  );
};
export default React.memo(NavigationTabs);
